import React, { useState } from "react";
import { Drawer, Typography, Row, Col, Input, Button, DatePicker } from "antd";
import { createLinkSecurityData, updateLinkSecurityData } from "api/customApis";
import utils, { CheckboxContainer } from "./utils";
import moment from "moment-timezone";

const { Text } = Typography;

export default function DrawerModal({
  visible,
  setDrawerStatus,
  collectionLink,
  collectionId,
  linkSettingsData,
  handleUpdateLinkSettingsData,
  linkSettingsId,
}) {
  const [data, setData] = useState(utils.setInitialdata(linkSettingsData));
  const [initdata, setInitdata] = useState(
    utils.setInitialdata(linkSettingsData)
  );

  const [errorState, setError] = useState({});

  const onToggleCheckBox = (e) => {
    setData({
      ...data,
      [e.target.id]: e.target.checked,
    });
  };

  const handleDate = (key, value) => {
    const d = value.format("YYYY-MM-DD");
    const expiry = {
      ...data?.expiry,
      [key]: moment(d),
    };
    setData({
      ...data,
      expiry,
    });
  };

  const handelInputData = (e) => {
    setData(initdata);
  };

  const handleNumberData = (e) => {
    const { value } = e.target;
    const reg = /^-?\d*(\d*)?$/;
    if ((!isNaN(value) && reg.test(value)) || value === "" || value === "-") {
      setData({
        ...data,
        [e.target.id]: value,
      });
    }
  };

  const validateDate = (expiry = {}) => {
    const todayDate = moment().format("YYYY-MM-DD");
    if (!expiry.to) {
      setError({ id: "setExpiry", message: "Select start and end date" });
      return false;
    }

    if (expiry.to.isBefore(todayDate)) {
      setError({ id: "setExpiry", message: "Past dates are not allowed" });
      return false;
    }

    // if (expiry.from > expiry.to) {
    //   setError({
    //     id: "setExpiry",
    //     message: "Start date should be greater than end date",
    //   });
    //   return false;
    // }
    return true;
  };

  const handleDone = () => {
    const todayDate = moment().format("YYYY-MM-DD");
    setError({});
    const finalData = {
      email: !!data.email,
    };
    if (data.setExpiry) {
      if (validateDate(data.expiry)) {
        finalData.expiry = {
          from: moment(todayDate),
          to: data?.expiry?.to,
          tz: moment.tz.guess(),
        };
      } else {
        return;
      }
    }

    if (data.setPasscode) {
      if (data.passcode && data?.passcode?.length === 6) {
        finalData.passcode = data.passcode;
      } else {
        setError({
          id: "setPasscode",
          message: "Enter a 6-digit passcode",
        });
        return;
      }
    }

    if (!linkSettingsId) {
      createLinkSecurityData(collectionLink, collectionId, finalData)
        .then((res1) => {
          const greyBoxData = utils.getGreyBoxData(finalData);
          handleUpdateLinkSettingsData(res1.data.id, greyBoxData, finalData);
          setDrawerStatus(false);
        })
        .catch((e) => {});
    } else {
      updateLinkSecurityData(linkSettingsId, finalData)
        .then((res2) => {
          const greyBoxData = utils.getGreyBoxData(finalData);
          handleUpdateLinkSettingsData(res2.data.id, greyBoxData, finalData);
          setDrawerStatus(false);
        })
        .catch((e) => {});
    }

    setInitdata({
      ...finalData,
      setPasscode: data.setPasscode,
      setExpiry: data.setExpiry,
    });
  };

  const renderButtons = () => {
    return (
      <Row align="bottom" style={{ marginTop: "1rem", marginBottom: "1rem" }}>
        <Col span={12}>
          <Button
            size="large"
            style={{
              color: "#4F5655",
              backgroundColor: "white",
              width: 100,
              border: "1px solid #CDCFCE",
              borderRadius: 4,
            }}
            onClick={() => {
              setDrawerStatus(false);
              handelInputData();
            }}
          >
            Cancel
          </Button>
        </Col>
        <Col span={12} style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            size="large"
            style={{
              color: "white",
              backgroundColor: "#363E3D",
              width: 100,
              border: "1px solid white",
              borderRadius: 4,
            }}
            onClick={handleDone}
          >
            Done
          </Button>
        </Col>
      </Row>
    );
  };

  const renderBody = () => {
    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <CheckboxContainer
          id="email"
          value={data.email}
          onChange={onToggleCheckBox}
          label1="Email required to view catalogue"
          label2="Catalogue will only be visible once email id is entered"
        />

        <CheckboxContainer
          id="setExpiry"
          value={data.setExpiry}
          onChange={onToggleCheckBox}
          label1="Link expires on"
          label2="Link will be automatically deactivated after the selected date"
          errorState={errorState}
        >
          <div
            style={{
              flexDirection: "row",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            {/*       <DatePicker
              value={data?.expiry?.from}
              placeholder="Select start date"
              onChange={(date) => {
                handleDate("from", date);
              }}
              disabled={!data.setExpiry}
              style={{
                marginRight: "0.5rem",
                flexGrow: 1,
                border:
                  errorState.id === "setExpiry"
                    ? "1px solid red"
                    : "1px solid #d9d9d9",
              }}
            />*/}
            <DatePicker
              allowClear={false}
              value={data?.expiry?.to}
              placeholder="Set expiry date"
              onChange={(date) => {
                handleDate("to", date);
              }}
              disabled={!data.setExpiry}
              style={{
                flexGrow: 1,
                border:
                  errorState.id === "setExpiry"
                    ? "1px solid red"
                    : "1px solid #d9d9d9",
              }}
            />
          </div>
        </CheckboxContainer>

        <CheckboxContainer
          id="setPasscode"
          value={data.setPasscode}
          onChange={onToggleCheckBox}
          label1="Passcode protect"
          label2="Add a 6-digit passcode to protect your catalogue"
          errorState={errorState}
        >
          <Input
            type="number"
            id="passcode"
            size="large"
            value={data.passcode}
            onChange={handleNumberData}
            placeholder="Enter 6-digit passcode"
            disabled={!data.setPasscode}
            style={{
              border:
                errorState.id === "setPasscode"
                  ? "1px solid red"
                  : "1px solid #d9d9d9",
            }}
          />
        </CheckboxContainer>
      </div>
    );
  };

  return (
    <>
      <Drawer
        width={500}
        placement="right"
        onClose={() => {
          setDrawerStatus(false);
        }}
        visible={visible}
        closable={false}
        maskClosable={false}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "100%",
          }}
        >
          <div>
            <Row>
              <Text
                style={{
                  marginBottom: "0.1rem",
                  fontSize: 18,
                  fontWeight: 800,
                }}
              >
                Update link settings
              </Text>
            </Row>
            <Text style={{ color: "#4F5655" }}>
              Make this link more secure by updating these settings
            </Text>
            <div
              style={{
                marginTop: "2rem",
                display: "flex",
                justifyContent: "space-between",
                borderRadius: 4,
              }}
            >
              {renderBody()}
            </div>
            {renderButtons()}
          </div>
        </div>
      </Drawer>
    </>
  );
}
